import { AxiosError } from "axios";

const formatDetail = (detail: unknown): string | null => {
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object") {
          const msg = (item as { msg?: unknown }).msg;
          if (typeof msg === "string" && msg.trim()) return msg.trim();
        }
        return null;
      })
      .filter((part): part is string => !!part);
    if (parts.length) return parts.join("; ");
  }
  if (detail && typeof detail === "object") {
    try {
      return JSON.stringify(detail);
    } catch {
      return null;
    }
  }
  return null;
};

// Prefer backend `detail` (incl. validation 407) over generic axios messages.
export const getAssessmentApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (error instanceof AxiosError) {
    const data = error.response?.data;
    if (data && typeof data === "object") {
      const fromDetail = formatDetail((data as { detail?: unknown }).detail);
      if (fromDetail) return fromDetail;
      const fromMessage = formatDetail(
        (data as { message?: unknown }).message
      );
      if (fromMessage) return fromMessage;
    }
    if (typeof data === "string" && data.trim()) return data.trim();

    const status = error.response?.status;
    if (status === 407) {
      return (
        formatDetail(error.response?.data) ||
        "Contest validation failed on the server"
      );
    }
    if (!error.response) {
      return "Network error while talking to the contest API";
    }
    if (typeof error.message === "string" && error.message.trim()) {
      return error.message;
    }
  } else if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string" && message.trim()) return message;
  } else if (typeof error === "string" && error.trim()) {
    return error;
  }

  return fallback;
};
